import { Route } from 'react-router-dom';
import Layout from '../components/layout';
import AllPages from '../Pages/Page/AllPages';
import NewPage from '../Pages/Page/NewPage';
import ProtectedRoute from '../components/ProtectedRoute';
export const PageRoutes = ({ menuActive, setMenuActive }) => (
    <>
        <Route path="/new-page" element={
            <ProtectedRoute>
                <Layout activePage='pages' menuActive={menuActive} setMenuActive={setMenuActive}>
                    <NewPage />
                </Layout>
            </ProtectedRoute>
        }
        />
        <Route path="/page/:pageId" element={
            <ProtectedRoute>
                <Layout activePage='pages' menuActive={menuActive} setMenuActive={setMenuActive}>
                    <NewPage />
                </Layout>
            </ProtectedRoute>
        }
        />
        <Route path="/all-pages" element={
            <ProtectedRoute>
                <Layout activePage='all-pages' menuActive={menuActive} setMenuActive={setMenuActive}>
                    <AllPages />
                </Layout>
            </ProtectedRoute>
        }
        />
    </>
);